import HeroSection from './components/HeroSection';
import BenefitsSection from './components/BenefitsSection';
import ServicesSection from './components/ServicesSection';
import BonusSection from './components/BonusSection';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <BenefitsSection />
      <ServicesSection />
      <BonusSection />
    </main>
  );
}
